<template>
  <div>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
      <div class="container-fluid">
        <router-link to="/roomList" class="navbar-brand">
          <img src="../assets/logo_white.png">
        </router-link>
        <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#Navbar" aria-controls="Navbar" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse justify-content-end" id="Navbar">
          <ul class="navbar-nav me-2 mb-lg-0">
            <li class="nav-item pt-2">
              <router-link to="/roomList" class="nav-link" aria-current="page">{{ $t("header.roomList") }}</router-link>
            </li>
            <li class="nav-item pt-2">
              <router-link to="/reserveCancel" class="nav-link" aria-current="page">{{ $t("header.reserveStatus") }}</router-link>
            </li>
            <li class="nav-item">
              <logout-form class="nav-link" ref="logoutForm" />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import LogoutForm from './LogoutForm.vue'

export default {
  name: 'NavBar',
  components: {
    LogoutForm
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      if (document.getElementById("Navbar") !== null) {
        document.getElementById("Navbar").classList.remove("show")
      }
      next
    })
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.navbar-brand{
  padding-top:0
}

.navbar img{
  height: 1.25rem;
}
</style>
